import { Button, Result } from 'antd';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import AppContext, { AppContextProps } from '../components/infrastructure/appContext';
import { ResultStatusType } from 'antd/lib/result';

export class ErrorPage extends Component<{ returnUrl?: string }> {
    static contextType = AppContext;

    render() {
        const { params } = this.context as AppContextProps;
        let id: ResultStatusType = params["id"] ?? "500";
        let returnUrl = params["returnurl"];
        if (returnUrl)
            returnUrl = decodeURIComponent(returnUrl);
        else
            returnUrl = '';

        const subTitle = (id: ResultStatusType) => {
            switch (id) {
                case "403":
                    return "به صفحه مورد نظر دسترسی ندارید";
                case "404":
                    return "صفحه مورد نظر یافت نشد";
                case "500":
                default:
                    return "متأسفانه خطایی رخ داده است، لطفا با پشتیبانی تماس بگیرید.";
            }
        };

        return (
            <Result
                status={id}
                title={id}
                subTitle={subTitle(id)}
                extra={<Button type="ghost"> <Link to={returnUrl}>بازگشت</Link></Button>}
            />
        );
    }
}

